import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-5b5b370c"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "contest-card-container"
};
var _hoisted_2 = {
  class: "left-content"
};
var _hoisted_3 = {
  class: "right-content"
};
var _hoisted_4 = ["title"];
var _hoisted_5 = {
  class: "tag-box"
};
var _hoisted_6 = ["title"];
var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", null, "主办单位：", -1);
});
var _hoisted_8 = ["title"];
var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", null, "承办单位：", -1);
});
var _hoisted_10 = ["title"];
var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", null, "协办单位：", -1);
});
var _hoisted_12 = ["title"];
var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", null, "技术支持：", -1);
});
var _hoisted_14 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "check-more"
  }, "了解详情", -1);
});
var _hoisted_15 = {
  class: "activity-info-box"
};
var _hoisted_16 = {
  key: 0,
  class: "info-line"
};
var _hoisted_17 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "title title-location"
  }, "活动地点", -1);
});
var _hoisted_18 = {
  class: "desc"
};
var _hoisted_19 = {
  key: 1,
  class: "info-line"
};
var _hoisted_20 = {
  class: "title title-time"
};
var _hoisted_21 = {
  class: "desc"
};
var _hoisted_22 = {
  key: 2,
  class: "info-line"
};
var _hoisted_23 = {
  class: "title title-custom"
};
var _hoisted_24 = {
  class: "desc"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_a_tag = _resolveComponent("a-tag");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: "status-tag",
    style: _normalizeStyle("background-color: ".concat(_ctx.data.statusColour))
  }, _toDisplayString(_ctx.data.status), 5), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
    class: "image-cover hover-image",
    style: _normalizeStyle("background-image:url(".concat(_ctx.data.listBanner, ")"))
  }, null, 4)]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", null, [_createElementVNode("div", {
    class: "contest-title",
    title: "".concat(_ctx.data.areaName, " | ").concat(_ctx.data.name)
  }, _toDisplayString(_ctx.data.name), 9, _hoisted_4), _createElementVNode("div", _hoisted_5, [_createVNode(_component_a_tag, {
    color: "orange"
  }, {
    default: _withCtx(function () {
      return [_createTextVNode(_toDisplayString(_ctx.data.contestItem), 1)];
    }),
    _: 1
  }), _createVNode(_component_a_tag, {
    color: "blue"
  }, {
    default: _withCtx(function () {
      return [_createTextVNode(_toDisplayString(_ctx.data.contestForm), 1)];
    }),
    _: 1
  })]), _ctx.data.holdItemName ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "sub-unit",
    title: _ctx.data.holdItemName
  }, [_hoisted_7, _createElementVNode("span", null, _toDisplayString(_ctx.data.holdItemName), 1)], 8, _hoisted_6)) : _createCommentVNode("", true), _ctx.data.undertakeItemName ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "sub-unit",
    title: _ctx.data.undertakeItemName
  }, [_hoisted_9, _createElementVNode("span", null, _toDisplayString(_ctx.data.undertakeItemName), 1)], 8, _hoisted_8)) : _createCommentVNode("", true), _ctx.data.assistItemName ? (_openBlock(), _createElementBlock("div", {
    key: 2,
    class: "sub-unit",
    title: _ctx.data.assistItemName
  }, [_hoisted_11, _createElementVNode("span", null, _toDisplayString(_ctx.data.assistItemName), 1)], 8, _hoisted_10)) : _createCommentVNode("", true), _ctx.data.supportItemName ? (_openBlock(), _createElementBlock("div", {
    key: 3,
    class: "sub-unit",
    title: _ctx.data.supportItemName
  }, [_hoisted_13, _createElementVNode("span", null, _toDisplayString(_ctx.data.supportItemName), 1)], 8, _hoisted_12)) : _createCommentVNode("", true), _hoisted_14]), _createElementVNode("div", _hoisted_15, [_ctx.pageConfig.showLocation ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_hoisted_17, _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.pageConfig.locationDesc || _ctx.data.activityArea), 1)])) : _createCommentVNode("", true), _ctx.pageConfig.showRegPeriod && _ctx.data.itemName ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.data.itemName), 1), _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.pageConfig.regPeriodDesc || _ctx.data.itemValue), 1)])) : _createCommentVNode("", true), _ctx.pageConfig.showCustomizeMsg ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.pageConfig.customizeTitle), 1), _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.pageConfig.customizeContent), 1)])) : _createCommentVNode("", true)])])]);
}